// ========================================
// Calendar Events Generator
// Generates events for FullCalendar from class data
// ========================================

const CalendarEvents = {
    /**
     * Generate calendar events from classes
     */
    generateCalendarEvents(filters = {}) {
        let classes = ClassService.getClasses();

        // Apply filters
        if (filters.professorId) {
            classes = classes.filter(c => c.professorId === filters.professorId);
        }
        if (filters.formationId) {
            classes = classes.filter(c => c.formationId === filters.formationId);
        }

        const events = [];
        const today = new Date();
        const startOfWeek = new Date(today);
        startOfWeek.setDate(today.getDate() - today.getDay());

        classes.forEach(cls => {
            // Validate class data
            if (!cls.startTime || !cls.endTime || cls.dayOfWeek === undefined) {
                console.warn('Skipping class with invalid data:', cls);
                return;
            }

            const subject = SubjectService.getSubject(cls.subjectId);
            const formation = FormationService.getFormation(cls.formationId);
            const professor = ProfessorService.getProfessor(cls.professorId);

            // Generate event for the specific day of week
            const eventDate = new Date(startOfWeek);
            eventDate.setDate(startOfWeek.getDate() + cls.dayOfWeek);

            const [startHour, startMin] = cls.startTime.split(':');
            const [endHour, endMin] = cls.endTime.split(':');

            const startDateTime = new Date(eventDate);
            startDateTime.setHours(parseInt(startHour), parseInt(startMin), 0);

            const endDateTime = new Date(eventDate);
            endDateTime.setHours(parseInt(endHour), parseInt(endMin), 0);

            const color = subject?.color || this.getColorForFormation(cls.formationId);

            events.push({
                title: `${subject ? subject.name : 'Clase'} - ${professor ? professor.firstName + ' ' + professor.lastName : 'Sin profesor'}`,
                start: startDateTime,
                end: endDateTime,
                backgroundColor: color,
                borderColor: color,
                extendedProps: {
                    classData: cls,
                    subjectName: subject ? subject.name : 'Desconocido',
                    formationName: formation ? formation.name : 'Desconocido',
                    professorName: professor ? `${professor.firstName} ${professor.lastName}` : 'Sin asignar'
                }
            });
        });

        return events;
    },

    /**
     * Get consistent color for a formation
     */
    getColorForFormation(formationId) {
        // Return default color if formationId is invalid
        if (!formationId || typeof formationId !== 'string') {
            return '#6c757d'; // Default gray color
        }

        // Fallback hash-based color if no subject color is found
        const colors = [
            '#667eea', '#764ba2', '#f093fb', '#4facfe',
            '#43e97b', '#fa709a', '#30cfd0', '#a8edea'
        ];
        const hash = formationId.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
        return colors[hash % colors.length];
    },

    /**
     * Format class data for calendar event
     */
    formatEventForCalendar(classData) {
        const subject = SubjectService.getSubject(classData.subjectId);
        const formation = FormationService.getFormation(classData.formationId);
        const professor = ProfessorService.getProfessor(classData.professorId);
        const color = subject?.color || this.getColorForFormation(classData.formationId);

        return {
            title: `${subject ? subject.name : 'Clase'} - ${professor ? professor.firstName + ' ' + professor.lastName : 'Sin profesor'}`,
            backgroundColor: color,
            borderColor: color,
            extendedProps: {
                classData,
                subjectName: subject ? subject.name : 'Desconocido',
                formationName: formation ? formation.name : 'Desconocido',
                professorName: professor ? `${professor.firstName} ${professor.lastName}` : 'Sin asignar'
            }
        };
    }
};

// Make CalendarEvents globally available
window.CalendarEvents = CalendarEvents;
